export async function saveImageToLibrary(_source: string, _extension = '.jpg') {
  throw new Error('Saving to the native media library is unavailable on web')
}
